import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { RecoilRoot } from "recoil";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import Helmet from "react-helmet";
import "./i18nextInit";
import LoadingPage from "./components/LoadingPage";

ReactDOM.render(
    <React.StrictMode>
        <Helmet>
            <meta property="og:title" content="Ho Jeng AR" />
        </Helmet>
        <Suspense fallback={<LoadingPage />}>
            <RecoilRoot>
                <App />
            </RecoilRoot>
        </Suspense>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
